import { render, staticRenderFns } from "./tab-produtos.vue?vue&type=template&id=c75040b0&scoped=true&"
import script from "./tab-produtos.vue?vue&type=script&lang=js&"
export * from "./tab-produtos.vue?vue&type=script&lang=js&"
import style0 from "./tab-produtos.vue?vue&type=style&index=0&id=c75040b0&scoped=true&lang=css&"
import style1 from "./tab-produtos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75040b0",
  null
  
)

export default component.exports